import React, { useState } from "react";
import trans from "../../utils";
import Button from "../Helpers/Button/Button";
import { useNavigate } from "react-router-dom";
import ConfirmationDeletion from "./ConfirmationDeletion";

export default function DeleteAccount() {
	const navigate = useNavigate();
	const [modal, setModal] = useState(false);
	return (
		<>
			<div className="account-header border-bottom">
				<div className="flex-between">
					<div className="d-block">
						<div className="fs-24 fw-600 text-capitalize">
							{trans("Delete Account")}
						</div>
						<p className="second-header-text">
							{trans(
								"Before you proceed, please take a moment to understand what happens to your data.",
							)}
						</p>
					</div>
				</div>
			</div>
			<div className="account">
				<div className="account-layout">
					<p
						className="delete-account-content"
						style={{ lineHeight: "1.8rem" }}
					>
						Deleting your account will permanently remove all data associated
						with it. This includes everything you have created, saved, or
						configured while using this service. Once deleted, none of this data
						can be retrieved or restored in any form. Your data will be removed
						from our systems within 30 days of deletion. During this period your
						account will be deactivated and inaccessible. After the 30 days, no
						trace of your data will remain on our servers or backups. If you
						have shared content or collaborated with others, those contributions
						may still appear in their accounts but will no longer be linked to
						you. Any active subscriptions will be cancelled immediately and no
						refunds will be issued for unused time.
					</p>
					<div className="d-flex align-items-center">
						<Button
							text={trans("Delete")}
							htmlType="button"
							type="primary"
							className="me-2"
							onClick={() => setModal(true)}
						/>
						<Button
							text={trans("Cancel Deletion")}
							type="default"
							htmlType="button"
							onClick={() => navigate("/setup/account")}
						/>
					</div>
				</div>
			</div>
			<ConfirmationDeletion modal={modal} setModal={setModal} />
		</>
	);
}
